import { PaypointsGroup } from "Components/Shared/PaypointsGroup";
import { isComgateProductCode } from "Components/Shared/Merchant/Products/AppProducts/constants";
import type { PayPointBaseDto, ProductCode } from "Infrastructure/Api/Api";
import { useNavigate } from "Navigation/useNavigate";
import { appUrl } from "Utils/UrlUtils";

type Props = {
  title: string;
  limit: number | null;
  paypoints: PayPointBaseDto[];
  productID: number | null;
  productCode?: ProductCode;
  merchantPublicID?: string;
  isReadOnly?: boolean;
};

export const PaypointsList = ({
  title,
  paypoints,
  limit,
  productID,
  productCode,
  merchantPublicID,
  isReadOnly = false,
}: Props) => {
  const navigate = useNavigate();

  const isAddButtonVisible =
    !isReadOnly &&
    !isComgateProductCode(productCode) &&
    (limit === null || paypoints.length < limit);

  const navigateToPaypointDetail = (paypoint: PayPointBaseDto) => {
    const params = new URLSearchParams();

    if (merchantPublicID) {
      params.set("merchantPublicID", merchantPublicID);
    }

    const queryString = params.toString();
    const url = queryString
      ? `${appUrl("paypoint-detail")}/${paypoint.publicID}?${queryString}`
      : `${appUrl("paypoint-detail")}/${paypoint.publicID}`;

    navigate(url);
  };

  const handleCreatePaypoint = () => {
    const params = new URLSearchParams();
    if (productID) {
      params.set("productID", productID.toString());
    }
    if (productCode) {
      params.set("productCode", productCode);
    }
    if (merchantPublicID) {
      params.set("merchantPublicID", merchantPublicID);
    }

    const queryString = params.toString();
    const url = queryString
      ? `${appUrl("new-paypoint")}?${queryString}`
      : appUrl("new-paypoint");
    navigate(url);
  };

  return (
    <PaypointsGroup
      title={title}
      paypoints={paypoints}
      limit={limit}
      onPaypointClick={navigateToPaypointDetail}
      onAddPaypoint={isAddButtonVisible ? handleCreatePaypoint : undefined}
    />
  );
};
